<template>
  <div class="modal-overlay" v-if="showUserCreateModal">
    <div class="modal-container">
      <div class="modal-header">
        <h3>Select the user you would like to add.</h3>
      </div>

      <div class="modal-body">
        <div class="user-option" :class="{ active: selectedOption === 'agents' }" @click="selectOption('agents')">
          <div class="icon-container">
            <img src="/img/icons/profile-circle.png" class="user-icon" alt="Agent user icon"/>
          </div>
          <div class="option-details">
            <div class="option-title">Agents</div>
            <div class="option-action">Add New Agent User</div>
          </div>
        </div>

        <div class="user-option" :class="{ active: selectedOption === 'bancassurance' }" @click="selectOption('bancassurance')">
          <div class="icon-container">
            <img src="/img/icons/product.png" class="user-icon" alt="Bancassurance user icon"/>
          </div>
          <div class="option-details">
            <div class="option-title">Bancassurance</div>
            <div class="option-action">Add New Agent User</div>
          </div>
        </div>

        <div class="user-option" :class="{ active: selectedOption === 'apaUsers' }" @click="selectOption('apaUsers')">
          <div class="icon-container">
            <img src="/img/icons/profile-circle.png" class="user-icon" alt="APA user icon"/>
          </div>
          <div class="option-details">
            <div class="option-title">APA Users</div>
            <div class="option-action">Add New APA User</div>
          </div>
        </div>

        <div class="user-option" :class="{ active: selectedOption === 'admins' }" @click="selectOption('admins')">
          <div class="icon-container">
            <img src="/img/icons/security.png" class="user-icon" alt="Admin user icon"/>
          </div>
          <div class="option-details">
            <div class="option-title">Admins</div>
            <div class="option-action">Add New Admin User</div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-cancel" @click="cancel">Cancel</button>
        <button class="btn btn-proceed" :disabled="!selectedOption" @click="captureUserDetails">Proceed</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddUserModal',
  data() {
    return {
      showUserCreateModal: true,
      selectedOption: null,
    };
  },
  methods: {
    selectOption(option) {
      this.selectedOption = option;
    },
    cancel() {
      this.showModal = false;
      this.$emit('cancel');
    },
    captureUserDetails() {
      if (this.selectedOption) {
        this.showModal = false;
        this.$emit('captureUserDetails', this.selectedOption);
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal-container {
  background-color: white;
  width: 500px;
  max-width: 90%;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  text-align: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: normal;
}

.modal-body {
  padding: 10px 0;
}

.user-option {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  border-left: 3px solid darkred;
  transition: background-color 0.2s;
  border: 1px solid #164194;
  margin: 12px 10px 15px 12px;
  border-radius: 7px;
}

.user-option:hover {
  background-color: #f5f5f5;
}

.user-option.active {
  border-left-color: #1976d2;
  background-color: #164194;
}

.user-option.active .icon-container {
  background-color: #fff;
}

.user-option.active .icon-container i {
  color: #164194;
}

.user-option.active .option-details .option-title,
.user-option.active .option-details .option-action {
  color: white;
}

.icon-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
}

.icon-container i {
  font-size: 18px;
  color: #555;
}

.option-details {
  flex-grow: 1;
}

.option-title {
  font-weight: bold;
  margin-bottom: 4px;
  color: #333;
}

.option-action {
  font-size: 13px;
  color: #1976d2;
}

.modal-footer {
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #eee;
}

.btn {
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
  border: none;
}

.btn-cancel {
  background-color: white;
  border: 1px solid #ddd;
  color: #333;
}

.btn-cancel:hover {
  background-color: #f5f5f5;
}

.btn-proceed {
  background-color: #1976d2;
  color: white;
}

.btn-proceed:hover {
  background-color: #1565c0;
}

.btn-proceed:disabled {
  background-color: #bbdefb;
  cursor: not-allowed;
}
</style>
